import Service, { inject as service } from '@ember/service';
import { computed } from '@ember/object';

const ROUTE_VALUE = {
  'signup.confirm-identity.index': 20,
  'signup.enter-identity-info.index': 20,
  'signup.confirm-business.index': 40,
  'signup.enter-business-info.index': 40,
  'signup.business-type': 60,
  'signup.entity-type': 60,
  'signup.business-management': 60,
  'signup.agreement': 80,
  'signup.account-open': 100,

  'signup.automation.splash': 0,
  'signup.automation.withholding': 33,
  'signup.automation.target': 66,
  'signup.automation.success': 100,
};

export default class SignupProgressService extends Service {
  @service router;

  @computed('router.currentRouteName')
  get value() {
    return ROUTE_VALUE[this.router.currentRouteName] || 0;
  }
}
